(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide')) {
    customElements.define(
      'size-guide',
      class SizeGuide extends HTMLElement {
        connectedCallback() {
          if (this._bound) return;
          this._bound = true;

          this.addEventListener('click', (event) => {
            const dialog = this.querySelector('dialog');
            if (!dialog) return;

            if (event.target.closest('[data-size-guide-open]')) {
              event.preventDefault();
              dialog.showModal();
              return;
            }

            if (event.target.closest('[data-size-guide-close]') || event.target === dialog) {
              dialog.close();
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
